import { forwardRef, InputHTMLAttributes, useId } from 'react';

type FileInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  enableReSelects?: boolean;
};

/**
 * An HTML <input type="file" /> element that
 * triggers the `onChange` event even if the user "re-selects" the same file
 */
export const SmartHTMLFileInput = forwardRef<HTMLInputElement, FileInputProps>(
  ({ enableReSelects = true, ...props }, ref) => {
    const id = useId();

    const actualId = props.id || id;

    return (
      <input
        ref={ref}
        type="file"
        {...props}
        id={actualId}
        onChange={(event) => {
          props.onChange?.(event);

          if (enableReSelects) event.target.value = '';
        }}
      />
    );
  },
);

SmartHTMLFileInput.displayName = 'SmartHTMLFileInput';
